/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Reason_SubscriptionInputs */

const fr_household_reason_subscription = /** @type {(inputs: Household_Reason_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement expiré`)
};

/**

* @param {Household_Reason_SubscriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_reason_subscription = /** @type {((inputs?: Household_Reason_SubscriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Reason_SubscriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_reason_subscription(inputs)
});